// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_string = require("rescript/lib/js/caml_string.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var KeyLogic$SmartcutsMacros = require("../KeyLogic.bs.js");
var ListUtils$SmartcutsMacros = require("../../../bs-utils/src/ListUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");

function humanize(code) {
  if (code >= 47) {
    switch (code) {
      case 91 :
          return "Left Window";
      case 92 :
          return "Right Window";
      case 93 :
          return "Select";
      case 112 :
          return "f1";
      case 113 :
          return "f2";
      case 114 :
          return "f3";
      case 115 :
          return "f4";
      case 116 :
          return "f5";
      case 117 :
          return "f6";
      case 118 :
          return "f7";
      case 119 :
          return "f8";
      case 120 :
          return "f9";
      case 121 :
          return "f10";
      case 122 :
          return "f11";
      case 123 :
          return "f12";
      case 94 :
      case 95 :
      case 96 :
      case 97 :
      case 98 :
      case 99 :
      case 100 :
      case 101 :
      case 102 :
      case 103 :
      case 104 :
      case 105 :
      case 106 :
      case 107 :
      case 108 :
      case 109 :
      case 110 :
      case 111 :
      case 124 :
      case 125 :
      case 126 :
      case 127 :
      case 128 :
      case 129 :
      case 130 :
      case 131 :
      case 132 :
      case 133 :
      case 134 :
      case 135 :
      case 136 :
      case 137 :
      case 138 :
      case 139 :
      case 140 :
      case 141 :
      case 142 :
      case 143 :
          return String.fromCharCode(code);
      case 144 :
          return "Num Lock";
      case 145 :
          return "Scroll Lock";
      default:
        return String.fromCharCode(code);
    }
  } else {
    if (code < 8) {
      return String.fromCharCode(code);
    }
    switch (code) {
      case 8 :
          return "Backspace";
      case 9 :
          return "Tab";
      case 13 :
          return "Enter";
      case 16 :
          return "Shift";
      case 17 :
          return "Ctrl";
      case 18 :
          return "Alt";
      case 19 :
          return "Pause/Break";
      case 20 :
          return "Caps Lock";
      case 27 :
          return "Esc";
      case 32 :
          return "Space";
      case 33 :
          return "Page Up";
      case 34 :
          return "Page Down";
      case 35 :
          return "End";
      case 36 :
          return "Home";
      case 37 :
          return "←";
      case 38 :
          return "↑";
      case 39 :
          return "→";
      case 40 :
          return "↓";
      case 10 :
      case 11 :
      case 12 :
      case 14 :
      case 15 :
      case 21 :
      case 22 :
      case 23 :
      case 24 :
      case 25 :
      case 26 :
      case 28 :
      case 29 :
      case 30 :
      case 31 :
      case 41 :
      case 42 :
      case 43 :
      case 44 :
          return String.fromCharCode(code);
      case 45 :
          return "Insert";
      case 46 :
          return "Delete";
      
    }
  }
}

var KeyDownKeyCode = {
  humanize: humanize
};

function t_encode(v) {
  switch (v.TAG | 0) {
    case /* Alt */0 :
        return [
                "Alt",
                Decco.stringToJson(v._0)
              ];
    case /* Tab */1 :
        return [
                "Tab",
                Decco.stringToJson(v._0)
              ];
    case /* Ctrl */2 :
        return [
                "Ctrl",
                Decco.stringToJson(v._0)
              ];
    case /* Meta */3 :
        return [
                "Meta",
                Decco.stringToJson(v._0)
              ];
    case /* Shift */4 :
        return [
                "Shift",
                Decco.stringToJson(v._0)
              ];
    case /* Char */5 :
        return [
                "Char",
                Decco.stringToJson(v._0)
              ];
    case /* KeyCode */6 :
        return [
                "KeyCode",
                Decco.intToJson(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Alt" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Alt */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Char" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Char */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Ctrl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Ctrl */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "KeyCode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KeyCode */6,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Meta" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Meta */3,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Shift" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Shift */4,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Tab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Tab */1,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  switch (v.TAG | 0) {
    case /* Alt */0 :
        return "Alt";
    case /* Tab */1 :
        return "Tab";
    case /* Ctrl */2 :
        return "Ctrl";
    case /* Meta */3 :
        return "Meta";
    case /* Shift */4 :
        return "Shift";
    case /* Char */5 :
        return v._0;
    case /* KeyCode */6 :
        return String(v._0);
    
  }
}

function humanize$1(v) {
  switch (v.TAG | 0) {
    case /* Alt */0 :
        return "[Alt]";
    case /* Tab */1 :
        return "[Tab]";
    case /* Ctrl */2 :
        return "[Ctrl]";
    case /* Meta */3 :
        return "[⌘ Cmd]";
    case /* Shift */4 :
        return "[Shift]";
    case /* Char */5 :
        return v._0;
    case /* KeyCode */6 :
        return "[" + (humanize(v._0) + "]");
    
  }
}

function keyComboComponentFromKeyAndCode(key, code) {
  switch (key) {
    case "Alt" :
        switch (code) {
          case "AltLeft" :
          case "AltRight" :
              return {
                      TAG: /* Alt */0,
                      _0: code
                    };
          default:
            
        }
        break;
    case "Control" :
        switch (code) {
          case "ControlLeft" :
          case "ControlRight" :
              return {
                      TAG: /* Ctrl */2,
                      _0: code
                    };
          default:
            
        }
        break;
    case "Meta" :
        switch (code) {
          case "MetaLeft" :
          case "MetaRight" :
              return {
                      TAG: /* Meta */3,
                      _0: code
                    };
          default:
            
        }
        break;
    case "Shift" :
        switch (code) {
          case "ShiftLeft" :
          case "ShiftRight" :
              return {
                      TAG: /* Shift */4,
                      _0: code
                    };
          default:
            
        }
        break;
    case "Tab" :
        switch (code) {
          case "TabLeft" :
          case "TabRight" :
              return {
                      TAG: /* Tab */1,
                      _0: code
                    };
          default:
            
        }
        break;
    default:
      
  }
  if (!KeyLogic$SmartcutsMacros.reCode.test(code)) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unhandled keyComboComponentFromKeyAndCode(~key, ~code) for (key, code) = (" + (key + (", " + (code + ")"))));
  }
  var $$char = KeyLogic$SmartcutsMacros.getCharFromCode(key, code);
  return {
          TAG: /* Char */5,
          _0: $$char
        };
}

function maybeCodeFromKeyComboComponent(v) {
  switch (v.TAG | 0) {
    case /* Char */5 :
    case /* KeyCode */6 :
        return ;
    default:
      return v._0;
  }
}

function isKeyComboComponentAModifier(component) {
  switch (component.TAG | 0) {
    case /* Char */5 :
    case /* KeyCode */6 :
        return false;
    default:
      return KeyLogic$SmartcutsMacros.isModifierCode(component._0);
  }
}

function isEquivalentComboComponent(key, code, component) {
  switch (component.TAG | 0) {
    case /* Alt */0 :
    case /* Ctrl */2 :
    case /* Meta */3 :
        break;
    case /* Char */5 :
        return component._0 === KeyLogic$SmartcutsMacros.getCharFromCode(key, code);
    default:
      return false;
  }
  switch (code) {
    case "AltLeft" :
        switch (component.TAG | 0) {
          case /* Alt */0 :
              return code === component._0;
          case /* Ctrl */2 :
          case /* Meta */3 :
              return false;
          
        }
    case "AltRight" :
        switch (component.TAG | 0) {
          case /* Alt */0 :
              return code === component._0;
          case /* Ctrl */2 :
          case /* Meta */3 :
              return false;
          
        }
    case "ControlLeft" :
        switch (component.TAG | 0) {
          case /* Ctrl */2 :
              return code === component._0;
          case /* Alt */0 :
          case /* Meta */3 :
              return false;
          
        }
    case "ControlRight" :
        switch (component.TAG | 0) {
          case /* Ctrl */2 :
              return code === component._0;
          case /* Alt */0 :
          case /* Meta */3 :
              return false;
          
        }
    case "MetaLeft" :
        switch (component.TAG | 0) {
          case /* Alt */0 :
          case /* Ctrl */2 :
              return false;
          case /* Meta */3 :
              return code === component._0;
          
        }
    case "MetaRight" :
        switch (component.TAG | 0) {
          case /* Alt */0 :
          case /* Ctrl */2 :
              return false;
          case /* Meta */3 :
              return code === component._0;
          
        }
    case "ShiftLeft" :
        switch (component.TAG | 0) {
          case /* Ctrl */2 :
              return code === component._0;
          case /* Alt */0 :
          case /* Meta */3 :
              return false;
          
        }
    case "ShiftRight" :
        switch (component.TAG | 0) {
          case /* Ctrl */2 :
              return code === component._0;
          case /* Alt */0 :
          case /* Meta */3 :
              return false;
          
        }
    case "TabLeft" :
        switch (component.TAG | 0) {
          case /* Alt */0 :
              return code === component._0;
          case /* Ctrl */2 :
          case /* Meta */3 :
              return false;
          
        }
    case "TabRight" :
        switch (component.TAG | 0) {
          case /* Alt */0 :
              return code === component._0;
          case /* Ctrl */2 :
          case /* Meta */3 :
              return false;
          
        }
    default:
      return false;
  }
}

var KeyComboComponent = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  humanize: humanize$1,
  keyComboComponentFromKeyAndCode: keyComboComponentFromKeyAndCode,
  maybeCodeFromKeyComboComponent: maybeCodeFromKeyComboComponent,
  isKeyComboComponentAModifier: isKeyComboComponentAModifier,
  isEquivalentComboComponent: isEquivalentComboComponent
};

function t_encode$1(v) {
  return Decco.listToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.listFromJson(t_decode, v);
}

function stringify$1(components) {
  return StringUtils$SmartcutsMacros.join(" + ", List.map(stringify, components));
}

function satisfies(predicate, len, combo) {
  return List.length(Belt_List.keep(combo, predicate)) >= len;
}

function hasAtLeast(keyDomains, combo) {
  var len = keyDomains.length;
  var predicate = function (key) {
    return Belt_Array.some(keyDomains, (function (doesKeyMatchDomain) {
                  return Curry._1(doesKeyMatchDomain, key);
                }));
  };
  return satisfies(predicate, len, combo);
}

function isShiftArrow(keys) {
  return hasAtLeast([
              (function (key) {
                  switch (key.TAG | 0) {
                    case /* Shift */4 :
                        return true;
                    case /* KeyCode */6 :
                        return key._0 === 16;
                    default:
                      return false;
                  }
                }),
              (function (key) {
                  if (key.TAG === /* KeyCode */6) {
                    return ListUtils$SmartcutsMacros.member(key._0, KeyLogic$SmartcutsMacros.keyCodesAssocWithCursorMove);
                  } else {
                    return false;
                  }
                })
            ], keys);
}

function isCmdOrCtrlShiftArrow(keys) {
  return hasAtLeast([
              (function (key) {
                  switch (key.TAG | 0) {
                    case /* Ctrl */2 :
                    case /* Meta */3 :
                        return true;
                    default:
                      return false;
                  }
                }),
              (function (key) {
                  switch (key.TAG | 0) {
                    case /* Shift */4 :
                        return true;
                    case /* KeyCode */6 :
                        return key._0 === 16;
                    default:
                      return false;
                  }
                }),
              (function (key) {
                  if (key.TAG === /* KeyCode */6) {
                    return ListUtils$SmartcutsMacros.member(key._0, KeyLogic$SmartcutsMacros.keyCodesAssocWithCursorMove);
                  } else {
                    return false;
                  }
                })
            ], keys);
}

function isCmdOrCtrlPlusChar(char_, keys) {
  return hasAtLeast([
              (function (key) {
                  switch (key.TAG | 0) {
                    case /* Ctrl */2 :
                    case /* Meta */3 :
                        return true;
                    default:
                      return false;
                  }
                }),
              (function (key) {
                  if (key.TAG === /* Char */5) {
                    return Caml_string.get(key._0, 0) === char_;
                  } else {
                    return false;
                  }
                })
            ], keys);
}

function isCmdOrCtrlA(keys) {
  return isCmdOrCtrlPlusChar(/* 'a' */97, keys);
}

function isCmdOrCtrlV(keys) {
  return isCmdOrCtrlPlusChar(/* 'v' */118, keys);
}

function isCmdOrCtrlC(keys) {
  return isCmdOrCtrlPlusChar(/* 'c' */99, keys);
}

function isCmdOrCtrlX(keys) {
  return isCmdOrCtrlPlusChar(/* 'x' */120, keys);
}

function isShiftEnter(keys) {
  return hasAtLeast([
              (function (key) {
                  switch (key.TAG | 0) {
                    case /* Shift */4 :
                        return true;
                    case /* KeyCode */6 :
                        return key._0 === 16;
                    default:
                      return false;
                  }
                }),
              (function (key) {
                  switch (key.TAG | 0) {
                    case /* Char */5 :
                        switch (key._0) {
                          case "Enter" :
                          case "NumpadEnter" :
                              return true;
                          default:
                            return false;
                        }
                    case /* KeyCode */6 :
                        return key._0 === 13;
                    default:
                      return false;
                  }
                })
            ], keys);
}

function areKeyComboComponentsOnlyModifierComponents(components) {
  return Belt_List.every(components, isKeyComboComponentAModifier);
}

function doKeyComboComponentsAlreadyContainKey(key, code, components) {
  return List.exists((function (param) {
                return isEquivalentComboComponent(key, code, param);
              }), components);
}

function resetKeyComboComponentsIfDuplicateKeyDown(key, code, components) {
  var maybeIndex = ListUtils$SmartcutsMacros.findIndex((function (param) {
          return isEquivalentComboComponent(key, code, param);
        }), components);
  if (maybeIndex !== undefined) {
    return {
            hd: keyComboComponentFromKeyAndCode(key, code),
            tl: /* [] */0
          };
  } else {
    return components;
  }
}

function order(components) {
  return Belt_List.reduce(components, [
                [],
                {
                  altKey: false,
                  ctrlKey: false,
                  metaKey: false,
                  shiftKey: false
                }
              ], (function (param, component) {
                  var cumulativeModifiers = param[1];
                  var newCumulativeModifiers;
                  switch (component.TAG | 0) {
                    case /* Alt */0 :
                        newCumulativeModifiers = {
                          altKey: true,
                          ctrlKey: cumulativeModifiers.ctrlKey,
                          metaKey: cumulativeModifiers.metaKey,
                          shiftKey: cumulativeModifiers.shiftKey
                        };
                        break;
                    case /* Ctrl */2 :
                        newCumulativeModifiers = {
                          altKey: cumulativeModifiers.altKey,
                          ctrlKey: true,
                          metaKey: cumulativeModifiers.metaKey,
                          shiftKey: cumulativeModifiers.shiftKey
                        };
                        break;
                    case /* Meta */3 :
                        newCumulativeModifiers = {
                          altKey: cumulativeModifiers.altKey,
                          ctrlKey: cumulativeModifiers.ctrlKey,
                          metaKey: true,
                          shiftKey: cumulativeModifiers.shiftKey
                        };
                        break;
                    case /* Shift */4 :
                        newCumulativeModifiers = {
                          altKey: cumulativeModifiers.altKey,
                          ctrlKey: cumulativeModifiers.ctrlKey,
                          metaKey: cumulativeModifiers.metaKey,
                          shiftKey: true
                        };
                        break;
                    default:
                      newCumulativeModifiers = cumulativeModifiers;
                  }
                  return [
                          $$Array.append(param[0], [[
                                  component,
                                  newCumulativeModifiers
                                ]]),
                          newCumulativeModifiers
                        ];
                }))[0];
}

var CommandValue = {
  KeyDownKeyCode: KeyDownKeyCode,
  KeyComboComponent: KeyComboComponent,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  satisfies: satisfies,
  hasAtLeast: hasAtLeast,
  isShiftArrow: isShiftArrow,
  isCmdOrCtrlShiftArrow: isCmdOrCtrlShiftArrow,
  isCmdOrCtrlPlusChar: isCmdOrCtrlPlusChar,
  isCmdOrCtrlA: isCmdOrCtrlA,
  isCmdOrCtrlV: isCmdOrCtrlV,
  isCmdOrCtrlC: isCmdOrCtrlC,
  isCmdOrCtrlX: isCmdOrCtrlX,
  isShiftEnter: isShiftEnter,
  areKeyComboComponentsOnlyModifierComponents: areKeyComboComponentsOnlyModifierComponents,
  doKeyComboComponentsAlreadyContainKey: doKeyComboComponentsAlreadyContainKey,
  resetKeyComboComponentsIfDuplicateKeyDown: resetKeyComboComponentsIfDuplicateKeyDown,
  order: order
};

exports.CommandValue = CommandValue;
/* Util-SmartcutsMacros Not a pure module */
